module.exports = __webpack_public_path__ + "img/sim.bbf4e1a0.png";